<template>
    <div>
         <ThatsTable title="Items" ref="table" :multipleSelection="false" :endpoint="endpoint" :columns="columns" :newBtn="true" @open="openNewModal" @row-click="rowClick" :key="tableKey" :filterFormData="filterForm" @clearFilterForm="clearFilterForm">  
           <!--  <template #filter="{}">
                    <div>test</div>
            </template> -->





            <template #custom-right-culumns="{}">

            </template>

        

        </ThatsTable>


      <!--   <el-dialog title="Item Master" :visible.sync="itemFormDialog" :close-on-click-modal="false" width="40%" size="small" class="text-left filter-form">
            <div class="filter-dalog-body p-4">
                <slot name="filter"></slot>
            </div>

            <div class="filter-dalog-footer border-top border-light">
                <div class="d-flex align-items-center pr-4 pl-4">
                    <mdb-btn color="elegant" class="ml-0" size="sm"><i class="el-icon-search"></i> Save</mdb-btn>
                    <mdb-btn color="elegant" class="ml-0" size="sm" @click="itemFormDialog = false"><i class="el-icon-close"></i> Close</mdb-btn>
                </div>
            </div>

        </el-dialog>
 -->
        
        <BusinessPartnerDialog ref="moduleComponentForm" @success="refreshTable"></BusinessPartnerDialog>
    </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import { mapGetters, mapMutations,mapActions } from 'vuex';
import ThatsTable from './Table'
import {mdbTabs, mdbRow, mdbCol, mdbBtn,mdbSelect, mdbInput,mdbBadge} from 'mdbvue'
import { MessageBox } from 'element-ui';
import DateRangePicker from 'vue2-daterange-picker'
import IntegrationWindow from '../../components/thats/IntegrationWindow'
import { ThatsDatePicker, ThatsMultiSelect, ThatsInput} from '../../components/thats/Thats'
import ThatsMultiVueSelect from '../../components/thats/MultiVueSelect'
import { ValidationObserver,ValidationProvider } from "vee-validate";

import { Loading } from 'element-ui';
import BusinessPartnerDialog from './BusinessPartnerDialog.vue';

export default {
        components:{
        ThatsTable,
        mdbTabs,
        mdbBadge,
        DateRangePicker, mdbRow, mdbCol,
        ThatsDatePicker,
        mdbBtn,
        ThatsInput,
        ThatsMultiSelect,
        ValidationObserver,ValidationProvider,ThatsMultiVueSelect,
        mdbSelect,
        mdbInput,
        IntegrationWindow,
        BusinessPartnerDialog
    },
    inject : [],
    provide(){
        return {
            btsApproverProvider : () => this.approverData
        }
    },
    data(){
        return {
            endpoint : 'local-supplier',
            approver : [],
            tableKey : 0,
            itemFormDialog : false,
            filterForm : {
                    searchTerm : [],
                    category : null,
                }
        }
    },


    created(){

        
    },

    mounted(){
        const self = this;

        // console.log("onmounted")
        this.$eventBus.$on('reloadTable',function(){
            self.tableKey++
            self.setFilters();
        })
    },
    methods: {

       ...mapActions('BusinessPartnerModule',['getRecord']),
       ...mapMutations('BusinessPartnerModule',['setFormStatusUpdate','setFormStatusCreate','setEmptyForm','setFilters','setFormData']),

        rowClick(row){
            const self = this;

            this.setFormStatusUpdate();
            this.setFormData(JSON.parse(JSON.stringify({...this.initialFormObject,...row})));
            this.$refs.moduleComponentForm.openDialog();
          
        },
        openNewModal(){
            this.setFormStatusCreate();
            this.setEmptyForm();
           this.$refs.moduleComponentForm.openDialog();
            // this.itemFormDialog = true
        },
        refreshTable(){
            this.tableKey++
            this.$refs.table.refreshTable()
           
        },

        clearFilterForm(){
            this.filterForm = JSON.parse(JSON.stringify(
                {
                    searchTerm : null,
                    category : null,
                }
            ))
        }

    },
    computed: {
        ...mapGetters('BusinessPartnerModule',['getLoading', 'columns','initialFormObject']),

        
    },
}


</script>